import React from "react";
import { useApplication } from "@/contexts/ApplicationContext";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { Truck, RefreshCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
const VehicleCollectionConfirmation = () => {
  const { application } = useApplication();
  const navigate = useNavigate();
  const collectionDate = application.vehicleCollection?.date
    ? new Date(application.vehicleCollection.date)
    : null;
  const handleReschedule = () => {
    navigate("/vehicle-collection");
  };
  return (
    <div className="max-w-md mx-auto">
      <Card>
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-green-100 p-3">
              <Truck className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="text-xl font-bold text-jungle mb-2">
            Collection Confirmed!
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg space-y-2">
            <h3 className="font-medium mb-2">
              Your Vehicle Collection Details
            </h3>
            {collectionDate && (
              <>
                <p className="text-sm">
                  <span className="font-medium">Date:</span>{" "}
                  {format(collectionDate, "EEEE, MMMM d, yyyy")}
                </p>
                <p className="text-sm">
                  <span className="font-medium">Time:</span>{" "}
                  {format(collectionDate, "h:mm a")}
                </p>
              </>
            )}
            <p className="text-sm">
              <span className="font-medium">Location:</span>{" "}
              {application.vehicleCollection.location
                ? `${application.vehicleCollection.location}`
                : "HIVED Operations Center"}
            </p>
          </div>
          <p className="text-sm text-gray-600 text-center">
            We're excited to get you on the road! Don't forget to bring your
            driving license or proof of identity.
          </p>
        </CardContent>
        <CardFooter className="flex justify-center pt-4">
          <Button
            variant="outline"
            onClick={handleReschedule}
            className="flex items-center gap-2"
          >
            <RefreshCcw className="h-4 w-4" />
            Reschedule Collection
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
export default VehicleCollectionConfirmation;
